<script setup>
import {reactive, onMounted, onUnmounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";
const compName = 'MyPayPeriodInitialComponent';

const props = defineProps({
  contextIdA: String
});

const data = reactive({
  defaultItem: {
    amount: null,
  },
  contextSchemaB: null,
  headers: [
    { title: 'Created Date', key: 'date' },
    { title: 'Description', key: 'description' },
    { title: 'Amount', key: 'amount' },
  ],
  items: [],
  isDisabled: false,
  loading: false,
  newItem: {
    amount: null,
  },
  openHoldbacksForm: false,
  search: null,
  valid: true
});

const formatISODateToAmerican = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

const getData = () => {
  ApiWrapper.post('holdbacks', 'my-pay-period-initial', {payPeriodId: props.contextIdA})
      .then((response) => {
        data.items = response.holdbacks;
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
        data.isDisabled = false
      })
}

onMounted(()=>{
  activeComponentStore.registerComponent(
      compName,
      [
        'holdbacks'
      ],
      getData
  );
  getData()
})

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Holdbacks</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row>
        <v-col cols="6">
          <v-text-field
              v-model="data.search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          loading-text="Loading... Please wait"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>